import { getFavoritedBrandsByCategoryid, getPointsForCategoryId } from './personalization';
export var getTopPersonalizationInfo = (supersWeNeedToLookAt, wasParms) => {
  var topPersonalizationInfo = {
    favoriteSuperCat: '',
    favoriteSuperCatPoints: 0,
    favoriteBrand: '',
    favoriteBrandPoints: 0,
    orderedBrandsInFavoriteSuperCat: {},
  };
  if (supersWeNeedToLookAt && supersWeNeedToLookAt == 'ALL') {
    supersWeNeedToLookAt = wasParms.personalizationCategoryIds.split('|');
  }
  let favoriteSuperCatId = 0;
  try {
    //Establish the favorite category
    for (var i = 0; i < supersWeNeedToLookAt.length; i++) {
      const thisSuperId = supersWeNeedToLookAt[i];
      let thisSuperPoints = 0;
      const personalizationData = getPointsForCategoryId(thisSuperId);
      thisSuperPoints += Object.values(personalizationData).reduce((total, thisPointVal) => total + thisPointVal, 0);

      const thisBrandFavoriteData = getFavoritedBrandsByCategoryid(thisSuperId);
      thisSuperPoints += thisBrandFavoriteData.length * wasParms.personalizationFavoriteBrandPointValue;
      if (thisSuperPoints > topPersonalizationInfo.favoriteSuperCatPoints) {
        favoriteSuperCatId = i;
        topPersonalizationInfo.favoriteSuperCat = thisSuperId;
        topPersonalizationInfo.favoriteSuperCatPoints = thisSuperPoints;
      }
    }
  } catch (e) {
    console.log(e);
  }
  try {
    //Establish the favorite brand from the category above
    const thisSuperId = supersWeNeedToLookAt[favoriteSuperCatId];
    let allBrandsWithPoints = {};
    //Populate allBrandsWithPoints with the points from favorited brands
    const brandFavoriteData = getFavoritedBrandsByCategoryid(thisSuperId);
    brandFavoriteData.forEach((brandName) => {
      allBrandsWithPoints[brandName] = Number(wasParms.personalizationFavoriteBrandPointValue);
    });
    //Populate allBrandsWithPoints with the points from organic navigation/addToBag/etc
    const categoryPersonlization = getPointsForCategoryId(thisSuperId);
    Object.keys(categoryPersonlization).forEach((brandName) => {
      const brandsPoints = categoryPersonlization[brandName];
      allBrandsWithPoints[brandName] = allBrandsWithPoints[brandName]
        ? allBrandsWithPoints[brandName] + brandsPoints
        : brandsPoints;
    });
    topPersonalizationInfo.orderedBrandsInFavoriteSuperCat = Object.entries(allBrandsWithPoints).sort(
      ([_keya, valueA], [_keyb, valueB]) => valueB - valueA
    );
    //find the brand in allBrandsWithPoints with the highest point value (favorited and organic combined)
    Object.keys(allBrandsWithPoints).forEach((brandName) => {
      const thisBrandPoints = allBrandsWithPoints[brandName];
      if (thisBrandPoints > topPersonalizationInfo.favoriteBrandPoints) {
        topPersonalizationInfo.favoriteBrand = brandName;
        topPersonalizationInfo.favoriteBrandPoints = thisBrandPoints;
      }
    });
  } catch (e) {
    console.log(e);
  }
  return topPersonalizationInfo;
};
export default getTopPersonalizationInfo;
